import React, {Component} from "react";
import {Translate} from "react-i18nify";

import * as config from "../../../constants/config";
import * as modelHelper from "../../../helpers/modelHelper";

import Button from "../generic/Button";
import imgCancel from "../../../resources/img/svgicons/cancel2.svg";
import imgDeso from "../../../resources/img/deso-logo.png";
import Modal from "../generic/Modal";

export default class HelpModal extends Component {
    handleCloseModalClick = () => {
        this.props.closeModal();
    };

    getHelpLink = (hasMessage) => {
        if (!this.props.displayHelpLink) {
            return null;
        }

        return (
            <div className="col-12">
                <span>{hasMessage ? <Translate value="help.visit" /> : <Translate value="help.visitNoLicense" />}</span>
                <a
                    className="color-primary margin-left-5"
                    href={this.props.helpLink}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Translate value="help.helpLink" />
                </a>
            </div>
        );
    };

    getHelpContent = (message) => {
        return modelHelper.buildModalSection(
            <div style={{alignContent: "baseline"}}>
                <div className="col-12 margin-bottom-10" dangerouslySetInnerHTML={{__html: message}} />
                <div className="col-12">{this.props.helpSettings.telephone}</div>
                <div className="col-12">{this.props.helpSettings.email}</div>
                {this.getHelpLink(true)}
            </div>,
            "flex-row-gap-10px flex-wrap slim-scroll text-align-center flex-align-center-horizontal"
        );
    };

    getFooter = () => {
        if (this.props.lightSoftware) {
            return modelHelper.buildModalSection(
                <React.Fragment>
                    <Button onClick={this.handleCloseModalClick} label={<Translate value="general.close" />} />
                </React.Fragment>
            );
        }
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    onClick={this.handleCloseModalClick}
                    label={<Translate value="general.close" />}
                    svgBefore={imgCancel}
                />
            </React.Fragment>
        );
    };

    getContent = () => {
        if (this.props.params.message !== "") {
            return this.getHelpContent(this.props.params.message);
        }

        if (this.props.helpSettings.message === "") {
            return modelHelper.buildModalSection(
                <div style={{alignContent: "baseline"}}>
                    <div className="col-12">
                        <Translate value="help.noHelpForLicense" />
                    </div>
                    <div className="col-12">
                        <Translate value="help.poweredByDeso" name={config.DESO} />
                    </div>
                    <div className="col-12">
                        <img src={imgDeso} className="deso-logo" alt="deso logo" />
                    </div>
                    {!this.props.lightSoftware && (
                        <React.Fragment>
                            <div className="col-12">{this.props.helpSettings.telephone}</div>
                            <div className="col-12">{this.props.helpSettings.email}</div>
                        </React.Fragment>
                    )}
                    {this.getHelpLink(false)}
                </div>,
                "flex-row-gap-10px flex-wrap slim-scroll text-align-center flex-align-center-horizontal"
            );
        }

        return this.getHelpContent(this.props.helpSettings.message);
    };

    render() {
        return (
            <Modal
                modalid={this.props.id}
                header={modelHelper.buildModalSection(<Translate value="help.help" />)}
                onClose={this.handleCloseModalClick}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={this.props.lightSoftware ? {height: "100%", width: "100%"} : {minWidth: "50%"}}
            />
        );
    }
}
